export default __webpack_public_path__ + "57f6477d3f878af87307876a22d126af.otf";